import Marquee from "react-fast-marquee";

const WORDS = ["Viaggi", "Cambiamento", "Libertà", "Autenticità", "Scoperta", "Crescita"];

export default function EditorialMarquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="py-10 md:py-14 border-y border-line bg-sand/60 overflow-hidden"
      aria-hidden="true"
    >
      <Marquee speed={28} gradient={false} pauseOnHover>
        {WORDS.map((w) => (
          <span key={w} className="flex items-center">
            <span className="font-serif text-3xl md:text-5xl italic text-ink/80 px-6 md:px-10">
              {w}
            </span>
            <span className="text-gold text-xl md:text-2xl">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
